module.exports = __webpack_public_path__ + "img/img-account-sec-10.png";